module.exports = __webpack_public_path__ + "img/09_Spenglerin_Foto_2022.ced37b81.jpg";